export default __webpack_public_path__ + "static/media/Triangle.a8a9fe86.svg";